import {combineReducers} from "redux";
import app from "./app/reducer";
import user from "./user/reducer";
import requests from "./requests/reducer";
import projects from "./projects/reducer";
import equipment from "./equipment/reducer";
import users from "./users/reducer";
import contractors from "./contractors/reducer";

export default combineReducers({
    app,
    user,
    requests,
    projects,
    equipment,
    users,
    contractors
})